var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDoubleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 21.5303C12.2375 21.8232 11.7626 21.8232 11.4697 21.5303L1.46969 11.5303C1.1768 11.2374 1.1768 10.7626 1.46969 10.4697C1.76258 10.1768 2.23746 10.1768 2.53035 10.4697L12 19.9393L21.4697 10.4697C21.7626 10.1768 22.2375 10.1768 22.5304 10.4697C22.8232 10.7626 22.8232 11.2374 22.5304 11.5303L12.5304 21.5303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 13.5303C12.3897 13.671 12.1989 13.75 12 13.75C11.8011 13.75 11.6103 13.671 11.4697 13.5303L1.46969 3.53033C1.25519 3.31583 1.19103 2.99324 1.30711 2.71299C1.4232 2.43273 1.69668 2.25 2.00002 2.25H22C22.3034 2.25 22.5768 2.43273 22.6929 2.71299C22.809 2.99324 22.7449 3.31583 22.5304 3.53033L12.5304 13.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleDown);
export default __webpack_public_path__ + "static/media/angle-double-down.fbae5b98c6d5c9e5638a327a94c2ca09.svg";
export { ForwardRef as ReactComponent };